var disable_register_button = function(){
  $('.create-account-button').attr('disabled','disabled');
  $('.create-account-button').addClass('disabled');
}
document.addEventListener('DOMContentLoaded', function() {
  const PHONE_NUM_LENGTH = 8;



  document.querySelector('#RegisterForm-phone').setAttribute('maxlength', PHONE_NUM_LENGTH);
  
    document.querySelector('#RegisterForm-phone').addEventListener('input', function(e) {
      disable_register_button();
      if($('#RegisterForm-phone').val().length==8 || $('#RegisterForm-phone').val().length==0){
        $('.send-mobile-otp-btn').next('.field__message').remove();
      }
      if($('#RegisterForm-phone').val().length<8){
        return false;
      }
      e.preventDefault();
      
      document.querySelector('#RegisterForm-phone').value = document.querySelector('#RegisterForm-phone').value.replaceAll(' ', '');
      const phoneNumberInputField = document.querySelector('#RegisterForm-phone');      
      const firstChar = phoneNumberInputField.value.charAt(0);
      const phoneDiv = phoneNumberInputField.parentNode.parentNode;
      const phoneNumberLen = phoneNumberInputField.value.length;
      const firstThreeDigits = phoneNumberInputField.value.substring(0,4);
      const unavailableArr = ['+974', '+971']

      let errorMessage = document.createElement('p');

      errorMessage.classList.add('field__message', 'field__message--error');



      if (phoneNumberLen != PHONE_NUM_LENGTH) {
        if (errorMessage) {
          errorMessage.textContent = 'Phone number must be ' + PHONE_NUM_LENGTH + ' digits';
        }

        phoneDiv.classList.add('field--error');
        if (document.querySelector('.field__message.field__message--error')) {
          document.querySelector('.field__message.field__message--error').remove();
        }
        return phoneDiv.append(errorMessage);
      } 

      
      if (firstChar == '+' || firstChar == '0' ) {
        if (errorMessage) {
          errorMessage.textContent = 'Please try again without 0 or +';
        }

        phoneDiv.classList.add('field--error');
        if (document.querySelector('.field__message.field__message--error')) {
          document.querySelector('.field__message.field__message--error').remove();
        }
        return phoneDiv.append(errorMessage);
      }
      
      let isUnavailable = false;
      
      for (let num in unavailableArr) {
        if (num == Number(firstThreeDigits)) {
          isUnavailable = true;
        }
      }
      
      if (isUnavailable) {
        if (errorMessage) {
          errorMessage.textContent = 'Please try again without 974 or 971';
        }

        phoneDiv.classList.add('field--error');
        if (document.querySelector('.field__message.field__message--error')) {
          document.querySelector('.field__message.field__message--error').remove();
        }
        return phoneDiv.append(errorMessage);
      }
      
    })
  
});